import settings from '@nobia/zeus-components/lib/settings'
import { css } from '@nobia/zeus-components/lib/styled'

import hthFonts from './hth'
import invitaFonts from './invita'
import keittiomaailmaFonts from './keittiomaailma'
import magnetFonts from './magnet'
import marbodalFonts from './marbodal'
import novartFonts from './novart'
import sigdalFonts from './sigdal'
import unoformFonts from './unoform'

const availableFonts = {
  invita: invitaFonts,
  marbodal: marbodalFonts,
  magnet: magnetFonts,
  sigdal: sigdalFonts,
  keittiomaailma: keittiomaailmaFonts,
  novart: novartFonts,
  hthdk: hthFonts,
  hthfi: hthFonts,
  hthse: hthFonts,
  hthno: hthFonts,
  hthde: hthFonts,
  unoform: unoformFonts,
  unoformse: unoformFonts,
  unoformno: unoformFonts,
  unoformbe: unoformFonts,
}

const brandFonts =
  css`
    ${availableFonts[settings.brand]}
  ` || css``

export default brandFonts
